var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"crossorigin":"anonymous","width":"1000","height":"1000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }